export const type = 'embed-block';
export const isEmbedBlock = node => node.type === type;
